import { useLocation } from 'react-router-dom';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, AppBar, Toolbar, Container, alpha, Stack, Button } from '@mui/material';
// hooks
import useOffSetTop from '../../hooks/useOffSetTop';
import useResponsive from '../../hooks/useResponsive';
// utils
import cssStyles from '../../utils/cssStyles';
// config
import { HEADER } from '../../config';
// components
import Logo from '../../components/Logo';
//
import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';
import { menuConfig as navConfig, secondaryNav } from './MenuConfig';
import { useAppContext } from '../../contexts/AppContext';

// ----------------------------------------------------------------------

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: HEADER.MOBILE_HEIGHT,
  [theme.breakpoints.up('md')]: {
    backgroundColor: alpha('#FFF', 1),
    height: HEADER.MAIN_DESKTOP_HEIGHT,
    transition: 'height 0.8s',
  },
}));

const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8,
}));

const ButtonStyle = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.warning.main,
  color: 'white',
  fontWeight: 'bold',
  borderRadius: 15,
  ':hover': {
    backgroundColor: theme.palette.warning.main,
  },
  boxShadow: theme.shadows[24],
}));

// ----------------------------------------------------------------------

export default function MainHeader() {
  const isOffset = useOffSetTop(HEADER.MAIN_DESKTOP_HEIGHT);
  const { handleOpen } = useAppContext();

  const theme = useTheme();

  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'md');

  const isHome = pathname === '/';

  return (
    <AppBar>
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            ...cssStyles(theme).bgBlur(),
            height: { md: HEADER.MAIN_DESKTOP_HEIGHT - 10 },
          }),
        }}
      >
        <Container
          sx={{
            display: 'flex',
            alignItems: isOffset ? 'center' : 'start',
            justifyContent: { xs: 'space-between' },
            pl: { md: 5 },
          }}
          maxWidth="xl"
        >
          <Logo sx={{ height: 80, width: 120 }}/>
          <Box sx={{ width: 15 }} />
          {isDesktop && (
            <MenuDesktop isOffset={isOffset} isHome={isHome} navConfig={navConfig} secondaryNav={secondaryNav} />
          )}
          {isDesktop && (
            <Stack alignSelf="center" justifyContent="center" position="relative">
              <Box
                id="google_translate_element"
                sx={{
                  '.skiptranslate > span': { display: 'none' },
                }}
              />
              <Box position="absolute" top={25} left={0} width={1} bgcolor="white" height={20} />

              <ButtonStyle size="small" sx={{ px: 2 }} onClick={handleOpen}>
                NEWSLETTER
              </ButtonStyle>
            </Stack>
          )}
          {!isDesktop && <MenuMobile isOffset={isOffset} isHome={isHome} navConfig={[...navConfig, ...secondaryNav]} />}
        </Container>
      </ToolbarStyle>

      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  );
}
